/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DashboardControllerDtoGetDashboardDataUserStatistics model module.
 * @module model/DashboardControllerDtoGetDashboardDataUserStatistics
 * @version 1.0
 */
class DashboardControllerDtoGetDashboardDataUserStatistics {
    /**
     * Constructs a new <code>DashboardControllerDtoGetDashboardDataUserStatistics</code>.
     * @alias module:model/DashboardControllerDtoGetDashboardDataUserStatistics
     */
    constructor() { 
        
        DashboardControllerDtoGetDashboardDataUserStatistics.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardControllerDtoGetDashboardDataUserStatistics</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardControllerDtoGetDashboardDataUserStatistics} obj Optional instance to populate.
     * @return {module:model/DashboardControllerDtoGetDashboardDataUserStatistics} The populated <code>DashboardControllerDtoGetDashboardDataUserStatistics</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardControllerDtoGetDashboardDataUserStatistics();

            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Date');
            }
            if (data.hasOwnProperty('totalUserCount')) {
                obj['totalUserCount'] = ApiClient.convertToType(data['totalUserCount'], 'Number');
            }
            if (data.hasOwnProperty('newUserCount')) {
                obj['newUserCount'] = ApiClient.convertToType(data['newUserCount'], 'Number');
            }
            if (data.hasOwnProperty('activeUserCount')) {
                obj['activeUserCount'] = ApiClient.convertToType(data['activeUserCount'], 'Number');
            }
            if (data.hasOwnProperty('nftHolderCount')) {
                obj['nftHolderCount'] = ApiClient.convertToType(data['nftHolderCount'], 'Number');
            }
            if (data.hasOwnProperty('nftHolderLoginCount')) {
                obj['nftHolderLoginCount'] = ApiClient.convertToType(data['nftHolderLoginCount'], 'Number');
            }
            if (data.hasOwnProperty('nonHolderLoginCount')) {
                obj['nonHolderLoginCount'] = ApiClient.convertToType(data['nonHolderLoginCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardControllerDtoGetDashboardDataUserStatistics</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardControllerDtoGetDashboardDataUserStatistics</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} timestamp
 */
DashboardControllerDtoGetDashboardDataUserStatistics.prototype['timestamp'] = undefined;

/**
 * @member {Number} totalUserCount
 */
DashboardControllerDtoGetDashboardDataUserStatistics.prototype['totalUserCount'] = undefined;

/**
 * @member {Number} newUserCount
 */
DashboardControllerDtoGetDashboardDataUserStatistics.prototype['newUserCount'] = undefined;

/**
 * @member {Number} activeUserCount
 */
DashboardControllerDtoGetDashboardDataUserStatistics.prototype['activeUserCount'] = undefined;

/**
 * @member {Number} nftHolderCount
 */
DashboardControllerDtoGetDashboardDataUserStatistics.prototype['nftHolderCount'] = undefined;

/**
 * @member {Number} nftHolderLoginCount
 */
DashboardControllerDtoGetDashboardDataUserStatistics.prototype['nftHolderLoginCount'] = undefined;

/**
 * @member {Number} nonHolderLoginCount
 */
DashboardControllerDtoGetDashboardDataUserStatistics.prototype['nonHolderLoginCount'] = undefined;






export default DashboardControllerDtoGetDashboardDataUserStatistics;

